import {defineStore} from "pinia"

export const useLayoutStore = defineStore("layout", {
  state: () => {
    const stored = localStorage.getItem('drawer')
    const initial = stored !== null ? Boolean(JSON.parse(stored)) : true

    return {
      drawer: initial as boolean,
    }
  },
  actions: {
    setDrawer(value: boolean) {
      this.drawer = value

      localStorage.setItem('drawer', JSON.stringify(value))
    },
  }
})
